// Typelizer digest c97317c90ff728595bd9b0707f837753
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from '../../runtime'
import { buildUrl } from '../../runtime'

export default {
  /** GET /accountant/onboarding */
  index: (options?: RouteOptions): RouteDefinition<'get'> => ({
    url: buildUrl('/accountant/onboarding', {}, options),
    method: 'get',
  }),

  /** GET /accountant/onboarding/:step */
  show: (
    params: { step: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'get'> => ({
    url: buildUrl('/accountant/onboarding/:step', params, options),
    method: 'get',
  }),

  /** PATCH /accountant/onboarding/:step */
  update: (
    params: { step: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'patch'> => ({
    url: buildUrl('/accountant/onboarding/:step', params, options),
    method: 'patch',
  }),
}
